var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.725,
    height: 129.269,
    viewBox: "0 0 159.725 129.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6132",
    "data-name": "Group 6132",
    transform: "translate(-134 -540)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6794",
    "data-name": "Path 6794",
    d: "M214.207,73.054v7.518H140.4s-4.9.749-4.9-4.9V61.762s-.749-3.962,3.962-3.962h23.52l6.02,9.982h40.677S214.207,68.531,214.207,73.054Z",
    transform: "translate(40.806 485.007)",
    fill: "#f2824c",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6829",
    "data-name": "Path 6829",
    d: "M-2986.068-1269.775a6.079,6.079,0,0,1-1.888-4.9v-59.012a4.849,4.849,0,0,1,.956-3.631,5.184,5.184,0,0,1,4.254-1.68h23.521a1.271,1.271,0,0,1,1.079.609l0,.007,5.656,9.365h40.126l.043.008a7.367,7.367,0,0,1,3.489,1.715,6.259,6.259,0,0,1,2.073,4.8v52.718a1.266,1.266,0,0,1-1.249,1.249h-73.714a3.643,3.643,0,0,1-.654.031A5.605,5.605,0,0,1-2986.068-1269.775Zm.609-4.9a3.789,3.789,0,0,0,1.04,3.019l0,0a3.133,3.133,0,0,0,2.01.654,3.152,3.152,0,0,0,.4-.022l.036-.005h72.719v-43.3h-76.206Zm76.206-42.144v-5.677a4.077,4.077,0,0,0-3.386-4.023h-40.566a1.272,1.272,0,0,1-1.079-.609l0-.006-5.656-9.366h-22.3v.031h-.5a2.97,2.97,0,0,0-2.33.756,2.418,2.418,0,0,0-.39,1.716l.006.041v17.137Z",
    transform: "translate(3156.249 1885.83)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2989",
    "data-name": "Ellipse 2989",
    cx: 51.814,
    cy: 10.013,
    rx: 51.814,
    ry: 10.013,
    transform: "translate(182.3 649.242)",
    fill: "#0f5a9c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 2.277,
    y2: 2.246,
    transform: "translate(257.26 637.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6812",
    "data-name": "Path 6812",
    d: "M426.382,379.582h0a6.119,6.119,0,0,1-8.672,0L404.826,366.7a6.119,6.119,0,0,1,0-8.672h0a6.119,6.119,0,0,1,8.672,0l12.883,12.883A6.119,6.119,0,0,1,426.382,379.582Z",
    transform: "translate(-143.293 279.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6825",
    "data-name": "Path 6825",
    d: "M-2970.633-1312.618l-12.884-12.883a6.821,6.821,0,0,1-2.027-4.865,6.864,6.864,0,0,1,.278-1.945.729.729,0,0,1-.278-.177l-2.247-2.246a.773.773,0,0,1,0-1.06.773.773,0,0,1,1.06,0l2.066,2.065a7.011,7.011,0,0,1,1.147-1.5,6.881,6.881,0,0,1,1.1-.9l-1.6-1.6a.774.774,0,0,1,0-1.061.773.773,0,0,1,1.06,0l1.955,1.955a6.893,6.893,0,0,1,7.217,1.6l12.883,12.883a6.819,6.819,0,0,1,2.028,4.866,6.819,6.819,0,0,1-2.028,4.866,6.814,6.814,0,0,1-4.866,2A6.869,6.869,0,0,1-2970.633-1312.618Zm-11.822-21.555a5.3,5.3,0,0,0-1.56,3.806,5.435,5.435,0,0,0,1.56,3.805l12.883,12.883a5.366,5.366,0,0,0,7.58,0,5.3,5.3,0,0,0,1.56-3.806,5.434,5.434,0,0,0-1.56-3.805l-12.884-12.883a5.284,5.284,0,0,0-3.774-1.56A5.462,5.462,0,0,0-2982.455-1334.173Z",
    transform: "translate(3244.519 1972.403)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 2.246,
    y2: 2.277,
    transform: "translate(261.034 634.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990",
    "data-name": "Ellipse 2990",
    cx: 33.877,
    cy: 33.877,
    r: 33.877,
    transform: "translate(204.572 576.154)",
    fill: "#f6ddd0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991",
    "data-name": "Ellipse 2991",
    cx: 33.877,
    cy: 33.877,
    r: 33.877,
    transform: "translate(199.301 576.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6798",
    "data-name": "Path 6798",
    d: "M241.526,231.551a34.626,34.626,0,1,1,34.626-34.626A34.667,34.667,0,0,1,241.526,231.551Zm0-67.754a33.128,33.128,0,1,0,33.128,33.128A33.149,33.149,0,0,0,241.526,163.8Z",
    transform: "translate(-8.348 413.105)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6799",
    "data-name": "Path 6799",
    d: "M253.154,237.908a29.354,29.354,0,1,1,29.354-29.354A29.382,29.382,0,0,1,253.154,237.908Zm0-57.21a27.856,27.856,0,1,0,27.856,27.856A27.9,27.9,0,0,0,253.154,180.7Z",
    transform: "translate(-19.977 401.477)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6800",
    "data-name": "Path 6800",
    d: "M493.263,237.125a3.463,3.463,0,1,1,3.463-3.463A3.475,3.475,0,0,1,493.263,237.125Zm0-6.02a2.558,2.558,0,1,0,2.558,2.558A2.57,2.57,0,0,0,493.263,231.1Z",
    transform: "translate(-203 366.386)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992",
    "data-name": "Ellipse 2992",
    cx: 1.497,
    cy: 1.497,
    r: 1.497,
    transform: "translate(288.766 598.552)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6826",
    "data-name": "Path 6826",
    d: "M-2983.445-1329.2v-3.775h-3.806a.759.759,0,0,1-.749-.749.759.759,0,0,1,.749-.749h3.806v-3.775a.759.759,0,0,1,.749-.749.759.759,0,0,1,.748.749v3.775h3.744a.759.759,0,0,1,.748.749.739.739,0,0,1-.748.749h-3.744v3.775a.758.758,0,0,1-.748.748A.759.759,0,0,1-2983.445-1329.2Z",
    transform: "translate(3124.007 1885.021)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6823",
    "data-name": "Path 6823",
    d: "M-2981.4-1331.334l-2.667-2.667-2.667,2.667a.735.735,0,0,1-.531.219.732.732,0,0,1-.53-.219.773.773,0,0,1,0-1.06l2.667-2.667-2.667-2.667a.774.774,0,0,1,0-1.061.774.774,0,0,1,1.061,0l2.667,2.667,2.667-2.667a.774.774,0,0,1,1.061,0,.773.773,0,0,1,0,1.061l-2.667,2.667,2.667,2.667a.772.772,0,0,1,0,1.06.732.732,0,0,1-.53.219A.735.735,0,0,1-2981.4-1331.334Z",
    transform: "translate(3205.183 1938.308)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6824",
    "data-name": "Path 6824",
    d: "M-2981.426-1331.334l-2.645-2.658-2.658,2.658a.735.735,0,0,1-.531.219.733.733,0,0,1-.53-.219.773.773,0,0,1,0-1.06l2.661-2.661-2.661-2.673a.774.774,0,0,1,0-1.061.774.774,0,0,1,1.061,0l2.667,2.667,2.667-2.667a.774.774,0,0,1,1.061,0,.773.773,0,0,1,0,1.061l-2.667,2.667,2.667,2.667a.772.772,0,0,1,0,1.06.754.754,0,0,1-.562.219A.731.731,0,0,1-2981.426-1331.334Z",
    transform: "translate(3230.044 1938.308)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6827",
    "data-name": "Path 6827",
    d: "M-2981.231-1324.682v-6.052h-6.02a.759.759,0,0,1-.749-.749.759.759,0,0,1,.749-.748h6.02v-6.021a.76.76,0,0,1,.749-.749.759.759,0,0,1,.749.749v6.021h6.052a.759.759,0,0,1,.749.748.759.759,0,0,1-.749.749h-6.052v6.052a.739.739,0,0,1-.749.749A.759.759,0,0,1-2981.231-1324.682Z",
    transform: "translate(3260.326 1879)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6810",
    "data-name": "Path 6810",
    d: "M301,299.523A5.733,5.733,0,0,1,307.02,295s6.02,0,6.02,4.523",
    transform: "translate(-73.094 321.8)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6811",
    "data-name": "Path 6811",
    d: "M301.9,297.716h-.031a.719.719,0,0,1-.717-.9c.405-1.5,1.778-4.211,6.27-4.211,2.184,0,5.3.686,6.02,4.43a.7.7,0,0,1-.686.842h-.031a.678.678,0,0,1-.686-.593c-.437-3.119-4.4-3.151-4.617-3.151-3.587,0-4.586,2.09-4.866,3.088A.8.8,0,0,1,301.9,297.716Z",
    transform: "translate(-73.179 323.452)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6814",
    "data-name": "Path 6814",
    d: "M.164,275.319l10.107,19.153a1.65,1.65,0,0,0,2.277.717l14.193-7.611a1.682,1.682,0,0,0,.655-2.308L16.1,264.9.85,273.042A1.692,1.692,0,0,0,.164,275.319Z",
    transform: "translate(134.034 342.511)",
    fill: "#f2824c",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6828",
    "data-name": "Path 6828",
    d: "M-2977.08-1310.6a2.179,2.179,0,0,1-1.31-1.092l-9.358-18.031a2.215,2.215,0,0,1,.936-2.994l11.285-6.04c.011-.014.024-.029.038-.043a.535.535,0,0,1,.625-.156l.523.178,5.154,1.444a.45.45,0,0,1,.343.281l.118.216a.5.5,0,0,1,.191.347l8.3,15.127a2.334,2.334,0,0,1,.187,1.716,2.138,2.138,0,0,1-1.092,1.341l-14.193,7.611a4.455,4.455,0,0,1-1.092.187A2.345,2.345,0,0,1-2977.08-1310.6Zm-9.264-21.181a1.185,1.185,0,0,0-.437,1.5l9.357,18.03a1.172,1.172,0,0,0,.655.562,1,1,0,0,0,.842-.094l14.194-7.611a1.1,1.1,0,0,0,.53-.655,1,1,0,0,0-.094-.842l-8.067-14.709-3.226,1.732a.5.5,0,0,1-.281.094.231.231,0,0,1-.156-.031.606.606,0,0,1-.344-.281l-1.923-3.6Zm13.725-3.338,2.153-1.154-3.4-1.155Zm-4.928,18.343a.535.535,0,0,1,.249-.749l9.732-4.96a.56.56,0,0,1,.749.249.535.535,0,0,1-.25.749l-9.732,4.96a.732.732,0,0,1-.25.062A.555.555,0,0,1-2977.547-1316.777Zm-1.809-3.37a.533.533,0,0,1,.249-.748l9.3-4.742a.534.534,0,0,1,.748.25.533.533,0,0,1-.249.748l-9.3,4.742a.592.592,0,0,1-.249.062A.555.555,0,0,1-2979.356-1320.147Zm-2.121-3.524a.534.534,0,0,1,.249-.749l9.3-4.741a.534.534,0,0,1,.749.249.535.535,0,0,1-.25.749l-9.3,4.741a.336.336,0,0,1-.249.062A.553.553,0,0,1-2981.478-1323.671Zm-1.654-3.525a.535.535,0,0,1,.25-.749l7.58-3.868a.56.56,0,0,1,.749.25.535.535,0,0,1-.249.749l-7.549,3.868a.928.928,0,0,1-.281.062A.557.557,0,0,1-2983.132-1327.2Z",
    transform: "translate(3126.345 1946.024)",
    fill: "#0f5a9c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyItem);
export default __webpack_public_path__ + "static/media/empty-item.1b8e863e10c9a392486356350ff6d52c.svg";
export { ForwardRef as ReactComponent };